import Vue from 'vue'
import store from '../../store'
import resolveAppInfo from '../../components/Mounted/resolveAppInfo'
import useBridge from '../../utils/useBridge'
import {
    configWeixin
} from '../../utils/wxsdk'
import { pick } from 'lodash'
import {
    setFirstPage,
    setLocalConfig
} from '@/utils/session'
import { deleteLoginInfo } from '@/utils/loginInfo'
import { isWx } from '../../utils/ua'
import eventBus, { SHOW_LOADING } from '../../utils/eventBus'

export default router => {
    let initFlag = false
    router.beforeEach((to, from, next) => {
        if (from) {
            if (!initFlag) {
                const del = localStorage.getItem('delUserInfo')
                if (!del && isWx()) {
                    localStorage.setItem('delUserInfo', '1')
                    deleteLoginInfo()
                }
                setFirstPage(to)
                // 记录第一个路有
                configWeixin()
                initFlag = true
                resolveAppInfo(config => {
                    useBridge(Vue, config)
                    store.dispatch('initAppInfo', config)
                    const code = to.query.code
                    if (isWx() && !!code) {
                        eventBus.$emit(SHOW_LOADING, true)
                        setLocalConfig('code', code)
                        localStorage.setItem('code', code)

                        // source=officialAccounts(来源是公众号)
                        const source = to.query.source
                        // 用在绑定手机号码页面
                        const isOfficialAccounts = source === 'officialAccounts'
                        // 微信环境，获取用户信息
                        store.dispatch('getWxUserInfo', code || '')
                            .then(wxUserInfo => {
                                eventBus.$emit(SHOW_LOADING, false)
                                if (isOfficialAccounts) {
                                    // 进入成功页面
                                    next({
                                        path: '/bindingResult',
                                        name: 'bindingResult',
                                        query: {
                                            phone: wxUserInfo.phone_number,
                                            boundType: 'bound'
                                        }
                                    })
                                } else {
                                    delete to.query.code
                                    next(to)
                                }
                            })
                            .catch(_ => {
                                // 没有手机号码停留在绑定手机号码页面
                                eventBus.$emit(SHOW_LOADING, false)
                                delete to.query.code
                                next(to)
                            })
                    } else {
                        next()
                    }
                })
            } else {
                if (to.path) {
                    _hmt.push(['_trackPageview', '/#' + to.path])
                }
                if (to.path === '/login' || to.path === '/bindingPhone') {
                    const route = pick(from, ['fullPath', 'path', 'query'])
                    setFirstPage(route)
                }
                next()
            }
        }
    })
}
